import { useImperativeHandle } from 'react'
import { number, node, shape, object } from 'prop-types'
import 'leaflet/dist/leaflet.css'
import { MapContainer, TileLayer, useMap } from 'react-leaflet'
import { posizioneToLatLng } from './utilMappa'

BaseMappa.propTypes = {
  centro: shape({
    latitudine: number.isRequired,
    longitudine: number.isRequired,
  }),
  altezza: number,
  zoom: number,
  children: node,
  mappaRef: object,
}

export default function BaseMappa(props) {
  const {
    centro,
    altezza = 500,
    zoom = 18,
    children,
    mappaRef,
  } = props

  return (
    <MapContainer
      center={[centro.latitudine, centro.longitudine]}
      zoom={zoom}
      style={{ height: altezza, width: '100%' }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
      />

      {children}

      <MappaAzioni
        centro={centro}
        zoom={zoom}
        mappaRef={mappaRef}
      />
    </MapContainer>
  )
}



function MappaAzioni(props) {
  const { centro, zoom, mappaRef } = props

  const map = useMap()

  useImperativeHandle(mappaRef, () => ({
    centraInPosizioneIniziale() {
      map.flyTo(posizioneToLatLng(centro), zoom)
    },
    centraInPosizione(posizione) {
      map.flyTo(posizioneToLatLng(posizione), zoom)
    }
  }))

  return null
}